import React, { useEffect, useRef, useState } from "react";
import { Sparkles } from "lucide-react";
import { Card } from "./Primitives";

const KEY = "vz.reduce_motion";

/** Apply the current preference on app boot. Import this once from index.js. */
export function applyMotionPreference() {
  try {
    const raw = window.localStorage.getItem(KEY);
    const on = raw === "1";
    document.body.classList.toggle("reduce-motion", on);
  } catch (_) { /* SSR / localStorage disabled */ }
}

export default function MotionPreferenceCard() {
  const [on, setOn] = useState(() => {
    try { return window.localStorage.getItem(KEY) === "1"; } catch (_) { return false; }
  });
  const userToggledRef = useRef(false);

  useEffect(() => {
    document.body.classList.toggle("reduce-motion", on);
    // Only persist to storage when the user actually flipped the switch — not
    // on mere page mount (that would silently create the key for every visit).
    if (!userToggledRef.current) return;
    try {
      if (on) window.localStorage.setItem(KEY, "1");
      else window.localStorage.removeItem(KEY);
    } catch (_) { /* noop */ }
  }, [on]);

  const handleToggle = (checked) => {
    userToggledRef.current = true;
    setOn(checked);
  };

  return (
    <Card testId="motion-preference-card">
      <div className="overline mb-2">Motion & Animations</div>
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="text-ink font-heading flex items-center gap-2">
            <Sparkles size={13} className="text-gold" />
            Disable liquid-morph animations
          </div>
          <div className="text-xs text-ink-soft mt-1 leading-relaxed max-w-md">
            Turns off the drifting glow blobs on hero panels and the shimmering skeleton pulse.
            Recommended on slower devices or if you prefer a calmer interface.
          </div>
        </div>
        <label className="relative inline-flex items-center cursor-pointer shrink-0 mt-1">
          <input
            type="checkbox"
            className="sr-only peer"
            checked={on}
            onChange={(e) => handleToggle(e.target.checked)}
            data-testid="motion-preference-toggle"
          />
          <div className="w-11 h-6 bg-navy/15 rounded-full peer peer-checked:bg-gold transition-colors after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:border-navy/10 after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-5" />
        </label>
      </div>
    </Card>
  );
}
